import React from "react";

import { Typography, Box } from "@mui/material";

import { grayDark } from "../colors";

export type MapStatusLegendItem = {
  color: string;
  label: string;
};

type MapStatusLegendProps = {
  items: MapStatusLegendItem[];
};

function MapStatusLegend(props: MapStatusLegendProps) {
  const { items } = props;

  return (
    <Box display="flex" gap={2}>
      {items.map(({ color, label }) => (
        <Box key={label} display="flex" alignItems="center" gap={0.5}>
          <Box
            sx={{
              width: 10,
              height: 10,
              borderRadius: "50%",
              backgroundColor: color,
            }}
          />
          <Typography variant="caption" sx={{ color: grayDark }}>
            {label}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}

export default MapStatusLegend;
